import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ClearFiltersATR, GetATRAction, ResetClearFiltersATR } from './atr.action';
import { MatDialog } from '@angular/material/dialog';
import { EnovaAlertsComponent } from '@/app/core/utils/enova-alerts/enova-alerts.component';
import { AtrService } from '@/app/core/services/atr/atr.service';
import { IDetailAtrRespose } from '@/app/core/interfaces/atr.interface';
import { catchError, tap, throwError } from 'rxjs';

export interface ATRStateModel {
  atrData: IDetailAtrRespose[];
  clearFilters: boolean;
}

@State<ATRStateModel>({
  name: 'atr',
  defaults: {
    atrData: [],
    clearFilters: false,
  },
})
@Injectable()
export class ATRState {
  @Selector() static getATRData(state: ATRStateModel): IDetailAtrRespose[] {
    return state?.atrData ? state.atrData : [];
  }

  @Selector() static getClearFilters(state: ATRStateModel): boolean {
    return state?.clearFilters || false;
  }

  constructor(
    public dialog: MatDialog,
    private atrService: AtrService
  ) {}

  @Action(GetATRAction)
  GetATRAction(ctx: StateContext<ATRStateModel>, { payload }: GetATRAction) {
    return this.atrService.getAtrData(payload).pipe(
      tap(response => {
        ctx.patchState({ atrData: response as IDetailAtrRespose[] });
      }),
      catchError(error => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            text: 'Ha ocurrido un error al obtener los datos',
            hiddeCancelBtn: true,
          },
        });
        return throwError(() => error);
      })
    );
  }

  @Action(ClearFiltersATR)
  ClearFiltersATR(ctx: StateContext<ATRStateModel>) {
    ctx.patchState({ clearFilters: true });
  }

  @Action(ResetClearFiltersATR)
  ResetClearFiltersATR(ctx: StateContext<ATRStateModel>) {
    ctx.patchState({ clearFilters: false });
  }
}
